export default "__VITE_PUBLIC_ASSET__22a7eb0f__"